import InboxClassificationFilter from '../store/schema/InboxClassificationFilter';
import InboxPlusPivotViewState from '../store/schema/InboxPlusPivotViewState';

export default function getInboxPlusDatapointCustomData(
    pivots: InboxPlusPivotViewState[],
    additionalData?: any
) {
    return {
        allPivotEnabled: isPivotEnabled(pivots, InboxClassificationFilter.None),
        focusedOtherPivotsEnabled: isPivotEnabled(pivots, InboxClassificationFilter.Focused),
        promotionsPivotEnabled: isPivotEnabled(pivots, InboxClassificationFilter.Promotions),
        socialPivotEnabled: isPivotEnabled(pivots, InboxClassificationFilter.Social),
        newslettersPivotEnabled: isPivotEnabled(pivots, InboxClassificationFilter.Newsletters),
        ...additionalData,
    };
}

function isPivotEnabled(
    allPivots: InboxPlusPivotViewState[],
    classificationFilterToCheck: InboxClassificationFilter
) {
    return (
        allPivots.filter(
            pivot =>
                pivot.InboxClassificationFilter === classificationFilterToCheck && pivot.isEnabled
        ).length > 0
    );
}
